// Fix 22 — ISO 3166-1 alpha-2 country list used by the Admin Schedule
// form and the public renderer.  Curated subset: GCC + MENA priority
// (DJ SPY's core market) followed by the rest of the world A→Z.  Flag
// emoji is derived from `code` via ``flagFromCode()`` — no image
// asset is stored.
export const COUNTRIES = [
  // GCC + MENA (top of list for the admin form)
  { code: "AE", name: "United Arab Emirates", name_ar: "الإمارات العربية المتحدة" },
  { code: "SA", name: "Saudi Arabia",         name_ar: "المملكة العربية السعودية" },
  { code: "BH", name: "Bahrain",              name_ar: "البحرين" },
  { code: "KW", name: "Kuwait",               name_ar: "الكويت" },
  { code: "QA", name: "Qatar",                name_ar: "قطر" },
  { code: "OM", name: "Oman",                 name_ar: "عُمان" },
  { code: "JO", name: "Jordan",               name_ar: "الأردن" },
  { code: "LB", name: "Lebanon",              name_ar: "لبنان" },
  { code: "EG", name: "Egypt",                name_ar: "مصر" },
  { code: "IQ", name: "Iraq",                 name_ar: "العراق" },
  { code: "SY", name: "Syria",                name_ar: "سوريا" },
  { code: "PS", name: "Palestine",            name_ar: "فلسطين" },
  { code: "YE", name: "Yemen",                name_ar: "اليمن" },
  { code: "MA", name: "Morocco",              name_ar: "المغرب" },
  { code: "TN", name: "Tunisia",              name_ar: "تونس" },
  { code: "DZ", name: "Algeria",              name_ar: "الجزائر" },
  { code: "LY", name: "Libya",                name_ar: "ليبيا" },
  { code: "SD", name: "Sudan",                name_ar: "السودان" },
  { code: "TR", name: "Türkiye",              name_ar: "تركيا" },
  // Rest of world A→Z
  { code: "AF", name: "Afghanistan",          name_ar: "أفغانستان" },
  { code: "AL", name: "Albania",              name_ar: "ألبانيا" },
  { code: "AR", name: "Argentina",            name_ar: "الأرجنتين" },
  { code: "AM", name: "Armenia",              name_ar: "أرمينيا" },
  { code: "AU", name: "Australia",            name_ar: "أستراليا" },
  { code: "AT", name: "Austria",              name_ar: "النمسا" },
  { code: "AZ", name: "Azerbaijan",           name_ar: "أذربيجان" },
  { code: "BD", name: "Bangladesh",           name_ar: "بنغلاديش" },
  { code: "BY", name: "Belarus",              name_ar: "بيلاروسيا" },
  { code: "BE", name: "Belgium",              name_ar: "بلجيكا" },
  { code: "BR", name: "Brazil",               name_ar: "البرازيل" },
  { code: "BG", name: "Bulgaria",             name_ar: "بلغاريا" },
  { code: "CA", name: "Canada",               name_ar: "كندا" },
  { code: "CN", name: "China",                name_ar: "الصين" },
  { code: "CO", name: "Colombia",             name_ar: "كولومبيا" },
  { code: "HR", name: "Croatia",              name_ar: "كرواتيا" },
  { code: "CY", name: "Cyprus",               name_ar: "قبرص" },
  { code: "CZ", name: "Czech Republic",       name_ar: "التشيك" },
  { code: "DK", name: "Denmark",              name_ar: "الدنمارك" },
  { code: "EE", name: "Estonia",              name_ar: "إستونيا" },
  { code: "ET", name: "Ethiopia",             name_ar: "إثيوبيا" },
  { code: "FI", name: "Finland",              name_ar: "فنلندا" },
  { code: "FR", name: "France",               name_ar: "فرنسا" },
  { code: "GE", name: "Georgia",              name_ar: "جورجيا" },
  { code: "DE", name: "Germany",              name_ar: "ألمانيا" },
  { code: "GH", name: "Ghana",                name_ar: "غانا" },
  { code: "GR", name: "Greece",               name_ar: "اليونان" },
  { code: "HK", name: "Hong Kong",            name_ar: "هونغ كونغ" },
  { code: "HU", name: "Hungary",              name_ar: "المجر" },
  { code: "IS", name: "Iceland",              name_ar: "آيسلندا" },
  { code: "IN", name: "India",                name_ar: "الهند" },
  { code: "ID", name: "Indonesia",            name_ar: "إندونيسيا" },
  { code: "IR", name: "Iran",                 name_ar: "إيران" },
  { code: "IE", name: "Ireland",              name_ar: "أيرلندا" },
  { code: "IT", name: "Italy",                name_ar: "إيطاليا" },
  { code: "JP", name: "Japan",                name_ar: "اليابان" },
  { code: "KZ", name: "Kazakhstan",           name_ar: "كازاخستان" },
  { code: "KE", name: "Kenya",                name_ar: "كينيا" },
  { code: "KG", name: "Kyrgyzstan",           name_ar: "قيرغيزستان" },
  { code: "LV", name: "Latvia",               name_ar: "لاتفيا" },
  { code: "LT", name: "Lithuania",            name_ar: "ليتوانيا" },
  { code: "LU", name: "Luxembourg",           name_ar: "لوكسمبورغ" },
  { code: "MO", name: "Macao",                name_ar: "ماكاو" },
  { code: "MY", name: "Malaysia",             name_ar: "ماليزيا" },
  { code: "MV", name: "Maldives",             name_ar: "المالديف" },
  { code: "MT", name: "Malta",                name_ar: "مالطا" },
  { code: "MX", name: "Mexico",               name_ar: "المكسيك" },
  { code: "MD", name: "Moldova",              name_ar: "مولدوفا" },
  { code: "MC", name: "Monaco",               name_ar: "موناكو" },
  { code: "ME", name: "Montenegro",           name_ar: "الجبل الأسود" },
  { code: "NL", name: "Netherlands",          name_ar: "هولندا" },
  { code: "NZ", name: "New Zealand",          name_ar: "نيوزيلندا" },
  { code: "NG", name: "Nigeria",              name_ar: "نيجيريا" },
  { code: "MK", name: "North Macedonia",      name_ar: "مقدونيا الشمالية" },
  { code: "NO", name: "Norway",               name_ar: "النرويج" },
  { code: "PK", name: "Pakistan",             name_ar: "باكستان" },
  { code: "PA", name: "Panama",               name_ar: "بنما" },
  { code: "PE", name: "Peru",                 name_ar: "بيرو" },
  { code: "PH", name: "Philippines",          name_ar: "الفلبين" },
  { code: "PL", name: "Poland",               name_ar: "بولندا" },
  { code: "PT", name: "Portugal",             name_ar: "البرتغال" },
  { code: "RO", name: "Romania",              name_ar: "رومانيا" },
  { code: "RU", name: "Russia",               name_ar: "روسيا" },
  { code: "RW", name: "Rwanda",               name_ar: "رواندا" },
  { code: "RS", name: "Serbia",               name_ar: "صربيا" },
  { code: "SG", name: "Singapore",            name_ar: "سنغافورة" },
  { code: "SK", name: "Slovakia",             name_ar: "سلوفاكيا" },
  { code: "SI", name: "Slovenia",             name_ar: "سلوفينيا" },
  { code: "ZA", name: "South Africa",         name_ar: "جنوب أفريقيا" },
  { code: "KR", name: "South Korea",          name_ar: "كوريا الجنوبية" },
  { code: "ES", name: "Spain",                name_ar: "إسبانيا" },
  { code: "LK", name: "Sri Lanka",            name_ar: "سريلانكا" },
  { code: "SE", name: "Sweden",               name_ar: "السويد" },
  { code: "CH", name: "Switzerland",          name_ar: "سويسرا" },
  { code: "TW", name: "Taiwan",               name_ar: "تايوان" },
  { code: "TZ", name: "Tanzania",             name_ar: "تنزانيا" },
  { code: "TH", name: "Thailand",             name_ar: "تايلاند" },
  { code: "UG", name: "Uganda",               name_ar: "أوغندا" },
  { code: "UA", name: "Ukraine",              name_ar: "أوكرانيا" },
  { code: "GB", name: "United Kingdom",       name_ar: "المملكة المتحدة" },
  { code: "US", name: "United States",        name_ar: "الولايات المتحدة" },
  { code: "UY", name: "Uruguay",              name_ar: "أوروغواي" },
  { code: "UZ", name: "Uzbekistan",           name_ar: "أوزبكستان" },
  { code: "VE", name: "Venezuela",            name_ar: "فنزويلا" },
  { code: "VN", name: "Vietnam",              name_ar: "فيتنام" },
  { code: "ZM", name: "Zambia",               name_ar: "زامبيا" },
  { code: "ZW", name: "Zimbabwe",             name_ar: "زيمبابوي" },
];

// Lookup helper — case-insensitive on code.
export function findCountry(code) {
  const s = String(code || "").trim().toUpperCase();
  return COUNTRIES.find((c) => c.code === s) || null;
}
